<!--
    Header nav icon, exported from Figma 4933-40092 (Login).
    Kept as a `nav-` set separate from the app's older icons: these carry the
    comp's line weights (1.25 in a ~22px box, 1.0 in the 18px hamburger), which
    the previous mix did not, and swapping the shared icons would change them
    everywhere else too. `currentColor` so the header controls the colour.
-->
<template>
    <svg aria-hidden="true" focusable="false" width="22" height="24.173" viewBox="0 0 22 24.173" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
    <path d="M11.2409 0.753906C13.9805 0.753906 16.1823 2.93164 16.1823 5.59375C16.1822 8.25579 13.9805 10.4336 11.2409 10.4336C8.50152 10.4334 6.30055 8.25564 6.30046 5.59375C6.30046 2.93178 8.50146 0.754139 11.2409 0.753906Z" stroke="currentColor" stroke-width="1.25" stroke-miterlimit="10"/>
    <path d="M5.02886 13.8062H17.5552C19.3263 13.8062 20.7369 15.2128 20.7369 16.9186V23.2525C20.7368 23.4049 20.6077 23.5483 20.4244 23.5484H2.16656C2.00779 23.5483 1.88406 23.4384 1.85406 23.3033L1.84722 23.2437V16.9186C1.84722 15.2074 3.2633 13.8062 5.02886 13.8062Z" stroke="currentColor" stroke-width="1.25" stroke-miterlimit="10"/>
    </g>
    </svg>
</template>
